export interface IVPoint {
    v: number; // Voltage
    i: number; // Current
}

// Dados completos de um módulo medido pelo flasher
export interface ModuleData {
    maxPower: number;
    maxVoltage: number; // Voc
    maxCurrent: number; // Isc
    ivCurve: IVPoint[]; // O array com "lots of data"
}

// Dados do produto para comparação/validação
export interface ProductData {
    nominalPower: number;
    powerTolerance: number;
    nominalVoc: number;
    vocTolerance: number;
    nominalIsc: number;
    iscTolerance: number;
}

export function generateIVData(numPoints = 10000): IVPoint[] {
    const data: IVPoint[] = [];
    const voc = 0.65;
    const isc = 9.5;
    const kneeSharpness = 80;

    for (let i = 0; i < numPoints; i++) {
        const v = (i / (numPoints - 1)) * (voc + 0.1);

        let i_val: number;
        if (v > voc) {
            i_val = 0;
        } else {
            i_val = isc * (1 - Math.pow(v / voc, kneeSharpness));
        }

        data.push({ v, i: Math.max(0, i_val) });
    }

    return data.sort((a, b) => a.v - b.v);
}
